import { render, staticRenderFns } from "./SignatureConfiguration.vue?vue&type=template&id=bb3d1532&scoped=true&"
import script from "./SignatureConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SignatureConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3d1532",
  null
  
)

export default component.exports